module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-login"
  }, [_c('section', {
    staticClass: "hero is-light is-fullheight"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('form', {
    staticClass: "box"
  }, [_c('p'), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-medium is-primary is-fullwidth",
    attrs: {
      "tag": "button",
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_vm._v("\n                    Login\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box has-text-centered"
  }, [_c('router-link', {
    staticClass: "button is-dark is-inverted is-fullwidth",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("\n                Register an account >\n              ")])], 1)])])])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control has-icon is-expanded"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("Forgot?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-144ed7b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 277
// module chunks = 1